import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Schema } from '@atlaskit/editor-prosemirror/model';
import { fg } from '@atlaskit/platform-feature-flags';
import { sanitizeNodes } from '../utils/sanitizeNodes';
import { fixExcludes } from './create-editor';
import { sortByOrder } from './sort-by-order';
export var createGenericMetada = function createGenericMetada(node) {
  var commonAttributes = _defineProperty({}, 'data-prosemirror-node-name', node.type.name);
  if (!node.type.isBlock) {
    return commonAttributes;
  }
  return _objectSpread(_objectSpread({}, commonAttributes), {}, _defineProperty({}, 'data-prosemirror-node-block', true));
};
export var wrapToDOMProxy = function wrapToDOMProxy(toDOM) {
  var toDOMProxy = new Proxy(toDOM, {
    apply: function apply(target, thisArg, argumentsList) {
      var result = Reflect.apply(target, thisArg, argumentsList);
      if (!Array.isArray(result)) {
        return result;
      }
      var node = argumentsList[0];
      var hasAttributes = _typeof(result[1]) === 'object' && !Array.isArray(result[1]);
      if (hasAttributes) {
        result[1] = Object.assign(result[1], createGenericMetada(node));
      } else {
        result.splice(1, 0, createGenericMetada(node));
      }
      return result;
    }
  });
  return toDOMProxy;
};
export var wrapNodeSpecProxy = function wrapNodeSpecProxy(spec) {
  var nodeSpecProxy = new Proxy(spec, {
    get: function get(target, prop, receiver) {
      var result = Reflect.get(target, prop, receiver);
      if (prop !== 'toDOM' || !result) {
        return result;
      }
      return wrapToDOMProxy(result);
    }
  });
  return nodeSpecProxy;
};
export function createSchema(editorConfig) {
  var marks = fixExcludes(editorConfig.marks.sort(sortByOrder('marks')).reduce(function (acc, mark) {
    acc[mark.name] = mark.mark;
    return acc;
  }, {}));
  var nodes = sanitizeNodes(editorConfig.nodes.sort(sortByOrder('nodes')).reduce(function (acc, node) {
    if (fg('platform_editor_breakout_use_css')) {
      acc[node.name] = wrapNodeSpecProxy(node.node);
    } else {
      acc[node.name] = node.node;
    }
    return acc;
  }, {}), marks);
  return new Schema({
    nodes: nodes,
    marks: marks
  });
}